import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { AttachmentReadModel } from '@assetaccountant/api/models/attachment-read-model';
import { AddAttachmentLinkCommand } from '@assetaccountant/api/models/attachments/add-attachment-link.command';
import { EditAttachmentLinkCommand } from '@assetaccountant/api/models/attachments/edit-attachment-link.command';
import { AttachmentApi } from '@assetaccountant/api/services/attachment.api';
import { RegisterObjectId } from '@assetaccountant/core/models/register-object-id';
import { TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-attachment-link-modal',
  templateUrl: './edit-attachment-link-modal.component.html',
  styleUrls: ['./edit-attachment-link-modal.component.scss'],
  standalone: false,
})
export class EditAttachmentLinkModalComponent implements OnInit {
  @Input() attachment?: AttachmentReadModel;
  @Input() registerObjectId?: RegisterObjectId;

  @Output() addlink = new EventEmitter<AttachmentReadModel>();

  form = this.fb.group({
    fileName: ['', Validators.required],
    externalStorageLink: [
      '',
      [Validators.required, Validators.pattern('(http|https)://(.*[a-zA-Z0-9]+.*)')],
    ],
  });

  constructor(
    public modal: NgbActiveModal,
    private attachmentApi: AttachmentApi,
    private fb: TypedFormBuilder,
  ) {}

  editLink() {
    if (!this.form.valid) {
      return;
    }
    this.submitForm();
  }

  submitForm() {
    const formValue = this.form.value;

    this.form.disable();
    if (this.attachment) {
      const editCommand: EditAttachmentLinkCommand = {
        objectType: this.attachment.objectType,
        objectId: this.attachment.objectId,
        attachmentId: this.attachment.attachmentId,
        fileName: formValue.fileName,
        externalStorageLink: formValue.externalStorageLink,
      };
      this.attachmentApi.editLink(editCommand).subscribe({
        next: reponse => {
          if (reponse && reponse.result) {
            this.addlink.emit(reponse.result);
          }
          this.modal.close();
        },
        error: () => this.form.enable(),
      });
    } else if (this.registerObjectId) {
      const addCommand: AddAttachmentLinkCommand = {
        objectType: this.registerObjectId.objectType,
        objectId: this.registerObjectId.objectId,
        fileName: formValue.fileName,
        externalStorageLink: formValue.externalStorageLink,
      };
      this.attachmentApi.addLink(addCommand).subscribe({
        next: reponse => {
          if (reponse && reponse.result) {
            this.addlink.emit(reponse.result);
          }
          this.modal.close();
        },
        error: () => this.form.enable(),
      });
    }
  }
  ngOnInit() {
    this.form.reset();
    this.form.markAsUntouched();
    if (this.attachment) {
      this.form.controls.fileName.setValue(this.attachment.fileName);
      this.form.controls.externalStorageLink.setValue(this.attachment.externalStorageLink ?? '');
    }
  }
}
